import PropTypes from 'prop-types';
import styles from './trustedBadge.module.scss';
import LogoAddress from '../logoAddress/logoAddress';
import SocialIcons from '../../socialIcons/socialIcons';

export default function TrustedBadge({
  logo = {
    path: '',
    alt: '',
    link: '/',
  },
  address = '88 Kearny Street, Suite 600<br>San Francisco, California 94108',
  socialIcons = null,
}) {
  return (
    <div className={styles.trustedBadge}>
      <LogoAddress logo={logo} address={address} />
      <div className={styles.right}>
        <SocialIcons items={socialIcons} title="" />
      </div>
    </div>
  );
}

TrustedBadge.propTypes = {
  logo: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  address: PropTypes.string,
  socialIcons: PropTypes.array,
};
